// @ts-nocheck
import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Container from '@material-ui/core/Container/Container';
import { SimpleBottomNavigation } from './bottom-navigation';
import Hidden from '@material-ui/core/Hidden/Hidden';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(0)
  },
  logo: {
    height: '1.9rem'
  },
  edgePadding: {
    padding: theme.spacing(0)
  },
  section: {
    display: 'flex'
  }
}));

function PrimarySearchAppBar() {
  const history = useHistory();
  const classes = useStyles();

  return (
    <div className={classes.grow}>
      <AppBar position="static" color="default">
        <Container>
          <Toolbar className={classes.edgePadding}>
            <Button color="inherit" onClick={() => history.push('/')}>
              <img
                className={classes.logo}
                src="http://cowabunga.co.za/static/img/logo.svg"
                alt="logo"
              />
            </Button>

            <div className={classes.grow} />
            <div className={classes.section}>
              <IconButton
                aria-label="account of current user"
                onClick={() => history.push('/admin')}
                color="inherit"
              >
                <SettingsOutlinedIcon />
              </IconButton>

              <Hidden xsDown>
                <Button color="inherit" onClick={() => history.push('/clients')}>
                  <small>
                    <b>Clients</b>
                  </small>
                </Button>
              </Hidden>

              <Hidden xsDown>
                <Button color="inherit" onClick={() => history.push('/users')}>
                  <small>
                    <b>Users</b>
                  </small>
                </Button>
              </Hidden>

              <IconButton
                edge="end"
                aria-label="account of current user"
                onClick={() => history.push('/account')}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

export default function NavBarComponent(props) {
  return (
    <>
      <PrimarySearchAppBar />
      {props.children}
      <Hidden smUp>
        <SimpleBottomNavigation />
      </Hidden>
    </>
  );
}
